const state = {duties: {tour: null, search: ''}}

const getters = {
  getDutiesSearchParam: state => state.duties
}

const actions = {
  updateDuties (context, searchParam) {
    context.commit('duties', searchParam)
  }
}

const mutations = {
  duties: (state, searchParam) => {
    state.duties = searchParam
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js